import { render } from "./error401Page.vue?vue&type=template&id=0104c272&scoped=true"
const script = {}

import "./error401Page.vue?vue&type=style&index=0&id=0104c272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0104c272"]])

export default __exports__